// https://kaligo.atlassian.net/browse/RD-5034
// If the Browser does not support animations, then don't enable animations.
// No need to polyfill - very few market share for non-animation enabled Browsers anyway.
// https://github.com/angular/angular/issues/45016#issuecomment-1046013903
// (The last part)
export const disableAnimations =
  !('animate' in document.documentElement) ||
  (navigator && /iPhone OS (8|9|10|11|12|13)_/.test(navigator.userAgent));
